export const textForValidation = [
  'at least 8 characters;',
  'at least one uppercase and one lowercase letter;',
  'only latin letters;',
  'at least one digit;',
  'at least 1 special character;',
];
